import useCustomTheme from '../hooks/theme-hook';
import { StyleSheet } from 'react-native';

const useOverlayStyles = () => {
  const theme = useCustomTheme();

  let overlay = {
    container: {
      // Use absoluteFill to cover the full parent area, including safe-area padding.
      ...StyleSheet.absoluteFillObject,
      justifyContent: 'center' as any,
      alignItems: 'center' as any,
    },
    overlay: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: theme.overlayColor,
    },
  };

  return overlay as typeof overlay;
};

export default useOverlayStyles;
